export default "__VITE_ASSET__s3BfMi_m__"